import { unix } from 'dayjs';
import get from 'lodash-es/get';

import { ProductInterface, SubscriptionInterface } from '@interface/billing/billing.interface';
import { isExist } from '@util/data/is-exist';

export const getPlanButtonText = (
  product: ProductInterface,
  subscription: SubscriptionInterface,
  isRenew: boolean,
  prevPlan?: any,
) => {
  const isBasePlan = get(subscription, 'plan.isBasePlan');
  const planId = get(subscription, 'plan.id', '');
  const planPrice = get(product, 'price', 0);
  const planType = get(product, 'type', 'monthly');
  const subscriptionPrice = get(subscription, ['plan', 'price'], 0);
  const hasTrialing = get(subscription, 'plans', []).some((plan: any) => plan.status === 'trialing');

  if (isRenew) return 'Renew';

  if (hasTrialing && subscription.cancelAt) {
    return !isExist(prevPlan?.cancelAt) && prevPlan?.id === product.id
      ? `Active since ${unix(subscription.cancelAt).format('DD/MM/YYYY')}`
      : `Will be available from ${unix(subscription.cancelAt).format('DD/MM/YYYY')}`;
  }

  if (product.id === planId) return 'Current';
  if (planType !== 'monthly') return 'Submit a request';
  if (isBasePlan || Number.isInteger(subscription.cancelAt) || product.type !== planType) return 'Subscribe';

  return planPrice > subscriptionPrice ? 'Upgrade' : 'Downgrade';
};

export const titleUnlimited = (value: number) => (value === -1 ? 'Unlimited' : value);
export const getSupport = (isSupport: boolean) => (isSupport ? 'Ticket support' : 'Shared Slack');
